module.exports = __webpack_public_path__ + "static/diyheatpump_image-39377106a7a2d5da65d6db3cbe9e1f6a.webp";